(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Collection image 1/2 switcher — robust version.
  // Works even before slideshow components upgrade; retries stragglers.
  (function () {
    let bound = false;
    let currentIndex = 0;

    // Direct DOM-level slide switch. Doesn't depend on the slideshow
    // component being upgraded — just scrolls the slides container.
    // The slideshow component, once upgraded, will read scroll position
    // as its own state, so user swipes/arrows still work afterwards.
    function hardSwitch(slideshow, index) {
      const slides = slideshow.querySelector('slideshow-slides');
      if (!slides) return false;

      const slideEls = slides.children;
      if (!slideEls.length) return false;

      const target = Math.min(index, slideEls.length - 1);
      const slide = slideEls[target];
      if (!slide) return false;

      // Most reliable: scroll the slides container so the target slide is aligned left.
      const left = slide.offsetLeft - slides.offsetLeft;
      slides.scrollTo({ left: left, behavior: 'instant' });

      // If the component is upgraded, also sync its internal state.
      try {
        if (typeof slideshow.select === 'function') {
          slideshow.select(target);
        }
      } catch (_) {}

      // Store the desired index so late-upgrading components can catch up.
      slideshow.setAttribute('data-desired-slide', String(target));
      return true;
    }

    function applyToAllSlideshows(index) {
      const slideshows = document.querySelectorAll('.product-grid__item slideshow-component');
      slideshows.forEach((ss) => hardSwitch(ss, index));
    }

    // Whenever a slideshow upgrades / becomes ready / scrolls into view,
    // re-apply the desired index from its data attribute.
    function catchUp(ss) {
      const desired = parseInt(ss.getAttribute('data-desired-slide') || '', 10);
      if (Number.isNaN(desired)) return;
      hardSwitch(ss, desired);
    }

    function init() {
      if (bound) return;

      const toggle = document.querySelector('[data-collection-image-switcher]');
      if (!toggle) return;

      const options = toggle.querySelectorAll('[data-image-index]');
      if (!options.length) return;

      bound = true;

      const setActiveButton = (index) => {
        options.forEach((btn) => {
          const btnIndex = parseInt(btn.getAttribute('data-image-index'), 10);
          const isActive = btnIndex === index;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };

      options.forEach((btn) => {
        btn.addEventListener('click', () => {
          const nextIndex = parseInt(btn.getAttribute('data-image-index'), 10);
          if (Number.isNaN(nextIndex) || nextIndex === currentIndex) return;
          currentIndex = nextIndex;
          setActiveButton(currentIndex);
          applyToAllSlideshows(currentIndex);

          // Retry after microtasks, after animation frame, and again 300ms
          // later to catch any slideshows that upgrade after the click.
          Promise.resolve().then(() => applyToAllSlideshows(currentIndex));
          requestAnimationFrame(() => applyToAllSlideshows(currentIndex));
          setTimeout(() => applyToAllSlideshows(currentIndex), 300);
        });
      });

      setActiveButton(currentIndex);

      // When a slideshow scrolls into view, catch it up to the desired index.
      // This handles lazy-initialized components far down the page.
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) catchUp(e.target);
          });
        }, { rootMargin: '200px' });

        const observeExisting = () => {
          document.querySelectorAll('.product-grid__item slideshow-component').forEach((ss) => {
            io.observe(ss);
          });
        };
        observeExisting();

        // When infinite scroll adds new cards, sync them and observe the new ones.
        const grid = document.querySelector('.collection-wrapper');
        if (grid) {
          const mo = new MutationObserver(() => {
            if (currentIndex !== 0) applyToAllSlideshows(currentIndex);
            observeExisting();
          });
          mo.observe(grid, { childList: true, subtree: true });
        }
      } else {
        // Fallback for very old browsers.
        const grid = document.querySelector('.collection-wrapper');
        if (grid) {
          const mo = new MutationObserver(() => {
            if (currentIndex !== 0) applyToAllSlideshows(currentIndex);
          });
          mo.observe(grid, { childList: true, subtree: true });
        }
      }
    }

    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', init, { once: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
